import React, { useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import {
  QuizTitle,
  QuizSubtitle,
  CTAButton,
  SecondaryButton,
} from '../styles/MFLancamentosStyles';
import {
  ConfirmationIcon,
  ScheduleGrid,
  TimeSlot,
  DayColumn,
  DayLabel,
  ScheduleWrapper,
  ScheduleTitle,
  Divider,
} from '../styles/LeadFormStyles';
import { WHATSAPP_DEFAULT, WHATSAPP_MESSAGE } from '../data/quizConfig';
import { supabase } from '../../../services/supabaseClient';

// Gera os próximos 5 dias úteis
const getNextBusinessDays = (count) => {
  const days = [];
  const date = new Date();
  while (days.length < count) {
    date.setDate(date.getDate() + 1);
    const dow = date.getDay();
    if (dow !== 0 && dow !== 6) {
      days.push(new Date(date));
    }
  }
  return days;
};

const SLOTS = ['09:00', '10:00', '11:00', '14:00', '15:00', '16:00'];

const formatDay = (date) => {
  const weekday = date.toLocaleDateString('pt-BR', { weekday: 'short' }).replace('.', '');
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return { weekday, short: `${day}/${month}` };
};

const LeadConfirmation = ({ lead }) => {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [scheduled, setScheduled] = useState(false);
  const businessDays = getNextBusinessDays(5);

  const whatsappUrl = `https://wa.me/${WHATSAPP_DEFAULT}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  const handleSchedule = async () => {
    if (!selectedSlot || !lead?.lead_id) {
      setScheduled(true);
      return;
    }

    // Salva agendamento no lead
    await supabase
      .from('mf_leads_site')
      .update({ agendamento: selectedSlot })
      .eq('id', lead.lead_id);

    // Notifica sobre o agendamento
    fetch('/api/mf-lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ lead_id: lead.lead_id, evento: 'agendamento_lancamentos' }),
    }).catch(() => {});

    setScheduled(true);
  };

  if (scheduled) {
    return (
      <>
        <ConfirmationIcon>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </ConfirmationIcon>
        <QuizTitle style={{ color: '#8AACC8' }}>Horario confirmado</QuizTitle>
        <QuizSubtitle style={{ maxWidth: '400px' }}>
          Nosso especialista entrara em contato no dia e horario selecionado.
          {lead?.nome ? ` Ate breve, ${lead.nome.split(' ')[0]}.` : ''}
        </QuizSubtitle>
      </>
    );
  }

  return (
    <>
      <ConfirmationIcon>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
          <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
      </ConfirmationIcon>

      <QuizTitle>Cadastro recebido</QuizTitle>
      <QuizSubtitle style={{ maxWidth: '440px' }}>
        Vamos ligar e enviar pelo WhatsApp as melhores opcoes para voce.
        Para falar com um especialista imediatamente, agende um horario abaixo.
      </QuizSubtitle>

      <Divider />

      <ScheduleWrapper>
        <ScheduleTitle>Escolha um horario</ScheduleTitle>
        <ScheduleGrid>
          {businessDays.map((date, di) => {
            const { weekday, short } = formatDay(date);
            return (
              <DayColumn key={di}>
                <DayLabel>
                  <span>{weekday}</span>
                  <span>{short}</span>
                </DayLabel>
                {SLOTS.map((time) => {
                  const key = `${short}-${time}`;
                  return (
                    <TimeSlot
                      key={key}
                      $selected={selectedSlot === key}
                      onClick={() => setSelectedSlot(key)}
                    >
                      {time}
                    </TimeSlot>
                  );
                })}
              </DayColumn>
            );
          })}
        </ScheduleGrid>
      </ScheduleWrapper>

      <CTAButton
        onClick={handleSchedule}
        disabled={!selectedSlot}
        style={{ marginTop: '24px' }}
      >
        Confirmar horario
      </CTAButton>

      <SecondaryButton href={whatsappUrl} target="_blank" rel="noopener noreferrer" style={{ marginTop: '16px' }}>
        <FaWhatsapp size={20} />
        Prefiro falar agora pelo WhatsApp
      </SecondaryButton>
    </>
  );
};

export default LeadConfirmation;
